import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Button from 'layout/atoms/Button/Button';
import ConfirmationModal from 'layout/molecules/ConfirmationModal';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { removeOrder, selectOrdersStatus } from 'store/ordersSlice';
function RemoveOrderModal() {
    var _a;
    const { t } = useTranslation(['orders', 'common']);
    const dispatch = useDispatch();
    const modalData = (_a = useSelector(selectModalByName('removeOrder'))) === null || _a === void 0 ? void 0 : _a.data;
    const status = useSelector(selectOrdersStatus);
    const orderId = modalData === null || modalData === void 0 ? void 0 : modalData.id;
    const orderName = modalData === null || modalData === void 0 ? void 0 : modalData.orderId;
    const handleRemove = () => {
        dispatch(removeOrder(orderId))
            .unwrap()
            .then(() => {
            dispatch(closeModal({ name: 'removeOrder' }));
        });
    };
    return (React.createElement(ConfirmationModal, { name: "removeOrder", header: React.createElement(React.Fragment, null,
            React.createElement(TrashSvg, null),
            t('REMOVE_ORDER')), buttons: React.createElement(Button, { color: "danger", onClick: handleRemove }, t('common:delete')), action: handleRemove, loading: status.remove === 'loading' },
        React.createElement("h2", null, t('REMOVE_ORDER_HEADER', { orderName })),
        React.createElement("p", null, t('REMOVE_ORDER_MESSAGE'))));
}
export default memo(RemoveOrderModal);
